import React from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LanguageToggleButton = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").slice(0, 2);

  const setLang = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    localStorage.setItem("i18n_picked", "1");
    axios.patch("/auth/me/preferences", { preferred_language: lng }, { withCredentials: true }).catch(() => {});
  };

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full bg-white/15 backdrop-blur-md border border-white/30 p-1 shadow-lg ${className}`}
      data-testid="landing-language-toggle"
    >
      <Globe className="w-4 h-4 text-white/80 ml-2" />
      <button
        onClick={() => setLang("en")}
        data-testid="landing-lang-en"
        className={`px-4 py-1.5 rounded-full text-sm font-bold transition-all ${
          lang === "en" ? "bg-amber-400 text-purple-950 shadow" : "text-white/80 hover:text-white"
        }`}
      >
        🇺🇸 EN
      </button>
      <button
        onClick={() => setLang("es")}
        data-testid="landing-lang-es"
        className={`px-4 py-1.5 rounded-full text-sm font-bold transition-all ${
          lang === "es" ? "bg-amber-400 text-purple-950 shadow" : "text-white/80 hover:text-white"
        }`}
      >
        🇪🇸 ES
      </button>
    </div>
  );
};

export default LanguageToggleButton;
